import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import { Page } from '../../../components/page/Page'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import { routes, enums } from '../../../constants'
import {
  changeFavorito,
  componentDidMount,
  componentDidUpdate,
  loadFavorito,
  onColumnReorder,
  onColumnToggle,
  onCsvExport,
  onPage,
  onSort,
} from '../../../utils/listPageContainerUtils'
import { actions } from '../movimentoestoque.actions'
import { showMessages } from '../../../store/message/message.actions'
import { MovimentoEstoqueList } from './movimento-estoque-list'
import './movimento-estoque-list.scss'
import utils from '../../../utils'
import { Toast } from 'primereact/toast'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import LtsCalendar from '../../../components/lottus/lts-calendar'

const mapStateToProps = (state) => {
  return {
    showHideColumns: state.crudMovimentoEstoqueState.showHideColumns,
    messages: state.crudMovimentoEstoqueState.messages,
    columns: state.crudMovimentoEstoqueState.columns,
    records: state.crudMovimentoEstoqueState.records,
    first: state.crudMovimentoEstoqueState.index,
    rows: state.crudMovimentoEstoqueState.max,
    totalRecords: state.crudMovimentoEstoqueState.count,
    sortField: state.crudMovimentoEstoqueState.sortField,
    order: state.crudMovimentoEstoqueState.sortOrder,
    selectedFilters: state.crudMovimentoEstoqueState.selectedFilters,
    selectedRecords: state.crudMovimentoEstoqueState.selectedRecords,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setSelectedRecords: (e) => {
      dispatch(actions.setSelectedRecords(e))
    },
    clearSelectedRecords: () => dispatch(actions.clearSelectedRecords()),
    changeFilter: (column, e) => {
      const target = e.target
      const campo = column.fieldJoin ? column.fieldJoin : target.name
      dispatch(actions.setSelectedFilters(campo, target.value, column.relacionamento, column.field))
      setTimeout(() => {
        dispatch(actions.executeFilter(`/lottustech/movimentoestoque/all`))
      }, 400)
    },
    load: () => dispatch(actions.load()),
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),
    loadFavorito: (menu) => {
      dispatch(actions.loadFavorito(menu))
    },
    removeFavorito: (menu) => {
      dispatch(actions.removeFavorito(menu))
    },
    adicionarFavorito: (menu) => {
      dispatch(actions.adicionarFavorito(menu))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
    showMessages: (messages, type) => dispatch(showMessages(messages, type)),
  }
}

class MovimentoEstoqueListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.columnSelect = React.createRef()
    this.toastRef = React.createRef()
    this.hideBtnImportacao = true
    this.showHideColumns = []
    this.showCSVButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      tipoMovimentoEstoque: 0,
      filtroListagemData: null,
    }

    this.onColumnToggle = this.onColumnToggle.bind(this)
  }

  onSuccess = () => {
    this.props.load()
    this.props.clearSelectedRecords()
  }

  //parametro com todas as colunas selecionadas atualmente
  onColumnToggle(event) {
    onColumnToggle(event, this)
  }

  // MÉTODO CHAMADO AO REORDENAR AS COLUNAS
  onColReorder(e, colunasAtuais) {
    onColumnReorder(e, colunasAtuais, this)
  }

  exportar(excel = true) {
    onCsvExport(this.props.records, this, actions, excel)
  }

  loadFavorito() {
    loadFavorito(this, actions)
  }

  changeFavorito() {
    changeFavorito(this, actions)
  }

  newHandler = () => {
    this.props.history.push(`${routes.PATH_MOVIMENTO_ESTOQUE}/novo`)
  }

  componentDidMount() {
    componentDidMount(this)
  }

  componentWillUnmount() {
    this.props.clearSelectedRecords()
  }

  componentDidUpdate(prevProps, prevState) {
    componentDidUpdate(this, prevProps, prevState)
  }

  onPage = (e) => {
    onPage(this, e)
  }

  onSort = (e) => {
    onSort(this, e)
  }

  onSelectionChange = (e) => {}

  buildHeader = () => {
    return <DefaultToolBar listPageContainer={this} title="Movimento Estoque" />
  }

  fieldFilter = (column) => {
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        value={this.props.selectedFilters[column.field]}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }

  formatColumn = (rowData, column) => {
    return utils.format(rowData, column)
  }

  tipoMovimentoColumnTemplate = (rowData, column) => {
    const rowDatum = rowData[column.field]
    if (rowDatum) {
      const tipoMovto = enums.CONVERTER_TIPO_MOVIMENTO_ESTOQUE[rowDatum]
      return <div title={tipoMovto}>{tipoMovto}</div>
    }
    return null
  }

  tipoMovimentoFilter = (column) => (
    <LtsDropdownIdValue
      name={'tipoMovimentoEstoque'}
      value={this.state.tipoMovimentoEstoque}
      onChange={(e) => this.onChangeTipoMovimento(e, column)}
      options={enums.ArrayTipoMovimentoEstoque}
      showOptionAll={true}
    />
  )

  onChangeTipoMovimento = (e, column) => {
    this.setState({ tipoMovimentoEstoque: e })
    this.props.changeFilter(column, { target: { name: 'tipoMovimentoEstoque', value: e.id } })
  }

  fieldCalendarFilter = (column) => {
    return (
      <LtsCalendar
        value={this.state.filtroListagemData}
        name={column.field}
        onChange={(e) => this.onChangeFiltroData(e, column)}
      />
    )
  }

  onChangeFiltroData = (e, column) => {
    this.setState({ filtroListagemData: e })
    this.props.changeFilter(column, { target: { name: 'dataMovimento', value: e } })
  }

  oidTemplate = (rowData) => {
    return <Link to={`${routes.PATH_PRODUTO}/${rowData.produto_oid}`}>{rowData.oid}</Link>
  }

  oidLink = ({ route, oid }) => {
    return <Link to={`${route}/${oid}`}>{oid}</Link>
  }

  produtoLinkBody = (rowData) => {
    return this.columnLinkBody(rowData, 'produto_descricao')
  }

  columnLinkBody = (rowData, field) => {
    if (rowData) {
      return (
        <div title={rowData[field]}>
          <Link to={`${routes.PATH_PRODUTO}/${rowData.produto_oid}`}>{rowData[field]}</Link>
        </div>
      )
    }
    return null
  }

  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.oidTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-date-body-width"
            filterHeaderClassName="table-column-date-filter-header-width"
            headerClassName="table-column-date-header-width"
          />
        )
      }

      if (col.field === 'lancamentoFinanceiro_oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={(rowData) =>
              this.oidLink({ route: routes.PATH_LANCAMENTO_FINANCEIRO, oid: rowData.lancamentoFinanceiro_oid })
            }
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-date-body-width"
            filterHeaderClassName="table-column-date-filter-header-width"
            headerClassName="table-column-date-header-width"
          />
        )
      }

      if (col.field === 'notaEntrada_oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={(rowData) => this.oidLink({ route: routes.PATH_NOTA_ENTRADA, oid: rowData.notaEntrada_oid })}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-date-body-width"
            filterHeaderClassName="table-column-date-filter-header-width"
            headerClassName="table-column-date-header-width"
          />
        )
      }

      if (col.field === 'dataMovimento') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.formatColumn}
            sortField={col.columnSortField}
            filterElement={this.fieldCalendarFilter(col)}
            bodyClassName="table-column-date-body-width"
            filterHeaderClassName="table-column-date-filter-header-width"
            headerClassName="table-column-date-header-width"
          />
        )
      }

      if (col.field === 'unidade_sigla') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-unidade-body-width"
            filterHeaderClassName="table-column-unidade-filter-header-width"
            headerClassName="table-column-unidade-header-width"
          />
        )
      }
      if (col.field === 'produto_descricao') {
        return (
          <Column
            {...col}
            body={this.produtoLinkBody}
            key={col.field}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-fornecedor-body-width"
            filterHeaderClassName="table-column-fornecedor-filter-header-width"
            headerClassName="table-column-fornecedor-header-width"
          />
        )
      }
      if (col.field === 'quantidade') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="table-column-numero-body-width"
            filterHeaderClassName="table-column-numero-filter-header-width"
            headerClassName="table-column-numero-header-width"
          />
        )
      }
      if (col.field === 'tipoMovimentoEstoque') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            body={this.tipoMovimentoColumnTemplate}
            filterElement={this.tipoMovimentoFilter(col)}
            bodyClassName="table-column-status-body-width"
            filterHeaderClassName="table-column-status-filter-header-width"
            headerClassName="table-column-status-header-width"
          />
        )
      }
      return null
    })
  }

  buildContent = () => {
    return (
      <div>
        <Toast ref={this.toastRef}></Toast>
        <MovimentoEstoqueList
          {...this.props}
          onSelectionChange={this.onSelectionChange}
          dataTableRef={(el) => (this.dataTableRef = el)}
          onColReorder={(e) => this.onColReorder(e, this.showHideColumns)}
          onPage={this.onPage}
          onSort={this.onSort}
          columns={this.defineColumns()}
        />
      </div>
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      return <Page header={this.buildHeader()} content={this.buildContent()} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MovimentoEstoqueListPageContainer)
